import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksStaffPayments: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
	},
	getRegulationsStagesPlanWorksStaffPaymentPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_PREVIEW,
	},
	getRegulationsStagesPlanWorksStaffPaymentPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_POPUP,
	},
	createRegulationsStagesPlanWorksStaffPayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
	},
	getRegulationsStagesPlanWorksStaffPayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
	},
	patchRegulationsStagesPlanWorksStaffPayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
	},
	putRegulationsStagesPlanWorksStaffPayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
	},
	deleteRegulationsStagesPlanWorksStaffPayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
				.DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
	},
}
